import Vue from 'vue';
import { mapGetters } from 'vuex';
import linkPage from '@editor/droplets/_bubble-options/components/link-page';
import { cardShape } from '@editor/droplets/utils';

export default Vue.component('edit-cardsStep', {
  template: require('./template.html'),
  computed: {
    ...mapGetters(['currentPage', 'currentSite', 'viewport']),
    setClass() {
      const cols = this.droplet.cards.length;
      let cls = `col-${12 / cols}`;
      cls = cls.replace(/\./g, '-');
      return cls;
    },
    minLimitReached() {
      return this.droplet.cards.length < 3;
    },
    maxLimitReached() {
      return this.droplet.cards.length >= this.cardLimit;
    },
  },
  components: {
    linkPage,
  },
  data() {
    return {
      cardLoading: false,
      activeCard: null,
      cardLimit: 5,
      editLinkForm: false,
    };
  },
  name: 'edit-cardsStep',
  props: ['droplet', 'show-edit-bubble'],
  methods: {
    addCard() {
      const total = this.droplet.cards.length;
      if (total <= this.cardLimit - 1) {
        const payload = {};
        payload.drp = this.droplet;
        const newCard = cardShape({ type: 'droplet.cardsStep.cardItem' })();
        payload.newCard = newCard;
        this.$store.dispatch('addNewStepCard', payload);
      }
    },
    removeCard(card, i) {
      const total = this.droplet.cards.length;
      if (total > 2) {
        this.$store.dispatch('spliceDropletVal', {
          array: this.droplet.cards,
          index: i,
        });
        this.$emit('css-generator');
        if (this.activeCard && card._id === this.activeCard._id) {
          this.resetFormValues();
        }
      }
    },
    bounceCard() {
      this.cardLoading = true;
      return new Promise((resolve) => {
        setTimeout(() => {
          this.cardLoading = false;
          resolve();
        }, 250);
      });
    },
    async setFormValues(card) {
      this.activeCard = card;
      this.editLinkForm = true;
      await this.bounceCard();
    },
    async resetFormValues() {
      this.activeCard = null;
      this.editLinkForm = false;
      await this.bounceCard();
    },
    // our global _DropletOptions calls this on cancel if
    // we want any data options in this component reverted
    drzRevertData() {
      this.resetFormValues();
      this.$emit('css-generator');
    },
    drzClickSave() {
      this.resetFormValues();
    },
    setBubbleSize(size) {
      this.$emit('set-bubble-size', size);
    },
    setLocals(v) {
      this.$emit('set-display', v);
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/cards-step/components/_edit-options/index.js